// extracted by mini-css-extract-plugin
module.exports = {"cellAction":"cellActions_cellAction__3I8O2","acknowledgedLabel":"cellActions_acknowledgedLabel__3KVbT","undoIcon":"cellActions_undoIcon__13PQo"};